import { Injectable, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { BehaviorSubject, Observable } from 'rxjs';
import { DialogComponent } from '../lib/container/dialog.component';

import { InfoDialogComponent } from './components/info-dialog/info-dialog.component';
import { InputDialogComponent } from './components/input-dialog/input-dialog.component';
import { GenericDialogComponent } from './components/generic-dialog/generic-dialog.component';

interface Positon {
  top: number;
  left: number;
}

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  @ViewChild(DialogComponent) dialogComponent!: DialogComponent;

  public btnDisabler: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public titleUpdater: BehaviorSubject<string> = new BehaviorSubject('');

  constructor(private matDialog: MatDialog) {}

  public flush() {
    this.matDialog.openDialogs.pop();
  }

  public openDialog(component: any, data: any, title: string, saveBtn?: string, text?: string, minWidth?: number, isCustomSave = false, disableClose = false) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = disableClose;
    dialogConfig.autoFocus = false;
    dialogConfig.minWidth = minWidth + '%';
    //dialogConfig.maxWidth = minWidth + '%';
    dialogConfig.data = {
      component: component,
      data: data,
      title: title,
      saveBtn: saveBtn,
      text: text,
      isCustomSave: isCustomSave,
    };

    const dialogRef = this.matDialog.open(DialogComponent, dialogConfig);
    return dialogRef.afterClosed();
  }

  public openContentDialog(component: any, data: any, title: string, saveBtn?: string, minWidth?: number): Observable<any> {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    dialogConfig.minWidth = minWidth + '%';
    // dialogConfig.backdropClass = 'backdropBackground';
    dialogConfig.data = {
      component: component,
      data: data,
      title: title,
      saveBtn: saveBtn,
    };

    const dialogRef = this.matDialog.open(DialogComponent, dialogConfig);
    return dialogRef.afterClosed();
  }

  public openPosDialog(component: any, data: any, title: string, position: Positon): Observable<any> {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = false;
    dialogConfig.position = { top: position.top.toString() + 'px', left: position.left.toString() + 'px' };
    dialogConfig.data = {
      component: component,
      data: data,
      title: title,
    };
    const dialogRef = this.matDialog.open(DialogComponent, dialogConfig);
    this.dialogComponent = dialogRef.componentInstance;

    return dialogRef.afterClosed();
  }

  public openTextDialog(component: any, data: any, title: string, saveBtn?: string, text?: string) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    // dialogConfig.minWidth = minWidth + '%';
    dialogConfig.backdropClass = 'backdropBackground';
    dialogConfig.data = {
      component: component,
      data: data,
      title: title,
      saveBtn: saveBtn,
      text: text,
    };

    const dialogRef = this.matDialog.open(DialogComponent, dialogConfig);
    this.dialogComponent = dialogRef.componentInstance;
    return dialogRef.afterClosed();
  }

  public openToUDialog(component: any, title: string, text: string | string[]) {
    const data = { isToUBanner: true };

    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = window.innerWidth < 600 ? '95vw' : '75vw';
    dialogConfig.maxWidth = '90vw';
    dialogConfig.data = {
      component: component,
      data: data,
      title: title,
      text: text,
    };

    const dialogRef = this.matDialog.open(DialogComponent, dialogConfig);
    this.dialogComponent = dialogRef.componentInstance;
    return dialogRef.afterClosed();
  }

  public openBlankDialog(component: any, isDraggable = true) {
    const data = { isToolBar: false };

    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      component: component,
      data: data,
      isDraggable: isDraggable,
    };
    const dialogRef = this.matDialog.open(DialogComponent, dialogConfig);
    this.dialogComponent = dialogRef.componentInstance;
    return dialogRef.afterClosed();
  }

  public openTreeDialog(component: any, data: any, title: string, saveBtn?: string, info?: string) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.minWidth = 30 + '%';
    dialogConfig.backdropClass = 'backdropBackground';
    dialogConfig.position = { left: `${280}px`, top: `${80}px` };
    dialogConfig.data = {
      component: component,
      data: data,
      title: title,
      info: info,
      saveBtn: saveBtn,
      text: undefined,
      isCustomSave: true,
    };

    const dialogRef = this.matDialog.open(DialogComponent, dialogConfig);
    this.dialogComponent = dialogRef.componentInstance;
    return dialogRef.afterClosed();
  }

  public disableBtn(isDisabled: boolean) {
    this.btnDisabler.next(isDisabled);
  }

  public changeTitle(title: any) {
    this.titleUpdater.next(title);
  }

  public closeDialog() {
    this.matDialog.closeAll();
  }

  public getDialog(dialog: string) {
    switch (dialog) {
      case 'InfoDialogComponent':
        return InfoDialogComponent;
      case 'InputDialogComponent':
        return InputDialogComponent;
      default:
        return GenericDialogComponent;
    }
  }
}
